import React from "react";
import { Nav as MNav } from "@magnetic/nav";

function NavDrawerItem({ item, i18nNamespace, i18n, basePath, navItemClick }) {
  const { isNew = false, text, href = "", to = "" } = item;

  let active = false;
  if (href && window.location.pathname.replace(basePath, "") === href) {
    active = true;
  }

  const additionalProps = {};
  if (href) {
    additionalProps.href = href;
  }

  if (to) {
    return <MNav.Drawer.Navigation to={to}>{i18n?.t(text, { ns: i18nNamespace }) || text}</MNav.Drawer.Navigation>;
  }
  console.log("NavDrawerItem item--", item);
  return (
    <MNav.Drawer.Item
      leadingIcon={item?.icon ? <img alt={item?.id} width={24} height={24} src={item?.icon} /> : ""}
      isNew={isNew}
      selected={active}
      onClick={(e) => navItemClick(e, item)}
      {...additionalProps}
    >
      {i18n?.t(text, { ns: i18nNamespace }) || text}
    </MNav.Drawer.Item>
  );
}

export default NavDrawerItem;
